import ConfigsWhiteLabelStage from "../env.json";
import ConfigsWhiteLabelProd from "../env.production.json";

// import client from "../api/carto"

export default function GetConfigWhiteLabel() {
  let returnConfigWhitelabel: any;
  const keywords = ["localhost", "stage"];

  try {
    const origin: any = window.location.origin.replace(/(^\w+:|^)\/\//, "");
    let configsWhiteLabel: any;

    if (
      keywords.some((keyword) => origin.includes(keyword)) &&
      ConfigsWhiteLabelStage
    ) {
      configsWhiteLabel = ConfigsWhiteLabelStage;
    } else {
      configsWhiteLabel = ConfigsWhiteLabelProd;
    }

    let configWhitelabel = configsWhiteLabel.find(
      (config: { identify: string }) => origin.includes(config.identify),
    );

    if (!configWhitelabel) {
      configWhitelabel = configsWhiteLabel?.find(
        (config: { identify: string }) =>
          config.identify === "etna" || config.identify === "cartopay-stage",
      );
    }

    //Extra
    const configsWhiteLabelExtra = configsWhiteLabel?.find(
      (config: { identifyExtra: string }) => config?.identifyExtra === "extra",
    );

    configWhitelabel = { ...configWhitelabel, ...configsWhiteLabelExtra };
    returnConfigWhitelabel = configWhitelabel;
  } catch (err) {
    console.error("GetConfigWhiteLabel failed:", err);
  }

  return returnConfigWhitelabel;
}
